import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import guest from './../middleware/guest'
import auth from './../middleware/auth'
import userHasNotCompletedData from './../middleware/userHasNotCompletedData'
import userHasCompletedData from './../middleware/userHasCompletedData'
import influencer from './../middleware/influencer'
import advertiser from './../middleware/advertiser'
import store from './../store/index'
import pubSite from './../middleware/pubSite'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'home' },
    meta: {
      middleware: [auth, userHasCompletedData]
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      middleware: [auth, userHasCompletedData]
    }
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    children: [
      {
        path: '',
        name: 'register-step1',
        component: () => import(/* webpackChunkName: "register-step1" */ '../views/register-partials/Step1.vue'),
        meta: {
          middleware: [guest]
        }
      },
      {
        path: ':type/step2',
        name: 'register-step2',
        component: () => import(/* webpackChunkName: "register-step2" */ '../views/register-partials/Step2.vue'),
        meta: {
          middleware: [guest]
        }
      },
      {
        path: 'verify/:hash',
        name: 'register-email-verify',
        component: () => import(/* webpackChunkName: "register-verify" */ '../views/register-partials/Verify.vue'),
        meta: {
          middleware: [guest]
        }
      }
    ],
    meta: {
      middleware: [guest]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      middleware: [guest]
    }
  },
  {
    path: '/first-time-create-profile',
    name: 'first-time-create-profile',
    component: () => import(/* webpackChunkName: "first-time-create-profile" */ '../views/FirstTimeCreateProfile.vue'),
    meta: {
      middleware: [auth, userHasNotCompletedData]
    }
  },
  {
    path: '/password-reminder',
    name: 'password-reminder',
    component: () => import(/* webpackChunkName: "password-reminder" */ '../views/PasswordReminder.vue'),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: '/password-reset/:hash',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "password-reset" */ '../views/PasswordReset.vue'),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: '/channels',
    component: () => import(/* webpackChunkName: "channels" */ '../views/Channels.vue'),
    children: [
      {
        path: '',
        name: 'channels',
        component: () => import(/* webpackChunkName: "channels-default" */ '../views/channels-partials/Default.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        }
      },
      {
        path: ':id',
        component: () => import(/* webpackChunkName: "channels-show" */ '../views/channels-partials/Show.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        },
        children: [
          {
            path: '',
            name: 'channels-show',
            component: () => import(/* webpackChunkName: "channels-details" */ '../views/channels-partials/Details.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            }
          },
          {
            path: 'delete',
            name: 'channels-delete',
            props: true,
            component: () => import(/* webpackChunkName: "channels-delete" */ '../views/channels-partials/Delete.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            }
          },
          {
            path: 'manual-analytics',
            name: 'channels-manual-analytics',
            component: () => import(/* webpackChunkName: "channels-manual-analytics" */ '../views/channels-partials/ManualAnalytics.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            }
          }
        ]
      },
      {
        path: 'add',
        name: 'channels-add',
        component: () => import(/* webpackChunkName: "channels-add" */ '../views/channels-partials/Add.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        }
      }
    ],
    meta: {
      middleware: [auth, userHasCompletedData, influencer]
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
    meta: {
      middleware: [auth, userHasCompletedData, advertiser]
    }
  },
  {
    path: '/favlist',
    name: 'favlist',
    component: () => import(/* webpackChunkName: "favlist" */ '../views/Favlist.vue'),
    meta: {
      middleware: [auth, userHasCompletedData, advertiser]
    }
  },

  {
    path: '/campaigns',
    component: () => import(/* webpackChunkName: "campaigns" */ '../views/Campaigns.vue'),
    meta: {
      middleware: [auth, userHasCompletedData]
    },
    children: [
      {
        path: '',
        name: 'campaigns',
        component: () => import(/* webpackChunkName: "campaigns-index" */ '../views/campaigns-partials/Index.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'add/:id?',
        name: 'campaigns-add',
        component: () => import(/* webpackChunkName: "campaigns-add" */ '../views/campaigns-partials/Add.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, advertiser]
        }
      },
      {
        path: 'details/:id',
        component: () => import(/* webpackChunkName: "campaigns-details" */ '../views/campaigns-partials/Details.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        },
        children: [
          {
            path: 'show',
            name: 'campaign-details',
            component: () => import(/* webpackChunkName: "campaigns-details-details" */ '../views/campaigns-partials/details/Details.vue'),
            meta: {
              middleware: [auth, userHasCompletedData]
            }
          },
          {
            path: 'messages',
            name: 'campaign-influencer-messages',
            component: () => import(/* webpackChunkName: "campaign-influencer-messages" */ '../views/campaigns-partials/influencers-views/Messages.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            }
          },
          {
            path: 'files',
            name: 'campaign-influencer-files',
            component: () => import(/* webpackChunkName: "campaign-influencer-files" */ '../views/campaigns-partials/influencers-views/Files.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            }
          },
          {
            path: 'members',
            component: () => import(/* webpackChunkName: "campaigns-members-index" */ '../views/campaigns-partials/members/Index.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, advertiser]
            },
            children: [
              {
                path: '',
                name: 'campaign-members',
                component: () => import(/* webpackChunkName: "campaigns-members-index-list" */ '../views/campaigns-partials/members/List.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, advertiser]
                }
              },
              {
                path: 'invite/recommended',
                name: 'campaign-members-invite-recommended',
                component: () => import(/* webpackChunkName: "campaign-members-invite-recommended" */ '../views/campaigns-partials/members/invite/Recommended.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, advertiser]
                }
              },
              {
                path: 'invite/whitelist',
                name: 'campaign-members-invite-whitelist',
                component: () => import(/* webpackChunkName: "campaign-members-invite-whitelist" */ '../views/campaigns-partials/members/invite/Whitelist.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, advertiser]
                }
              },
              {
                path: ':member',
                component: () => import(/* webpackChunkName: "campaign-members-member" */ '../views/campaigns-partials/members/member/Member.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, advertiser]
                },
                children: [
                  {
                    path: 'profile',
                    component: () => import(/* webpackChunkName: "campaign-members-member-profile" */ '../views/campaigns-partials/members/member/Profile.vue'),
                    meta: {
                      middleware: [auth, userHasCompletedData, advertiser]
                    },
                    children: [
                      {
                        path: '',
                        name: 'campaign-members-member-profile-details',
                        component: () => import(/* webpackChunkName: "profile-details-details" */ '../views/user-profile-partials/details-subviews/Details.vue'),
                        meta: {
                          middleware: [auth, userHasCompletedData, advertiser]
                        }
                      },
                      {
                        path: 'audience',
                        name: 'campaign-members-member-profile-audience',
                        component: () => import(/* webpackChunkName: "profile-audience" */ '../views/user-profile-partials/details-subviews/Audience.vue'),
                        meta: {
                          middleware: [auth, userHasCompletedData, advertiser]
                        }
                      }
                    ]
                  },
                  {
                    path: 'messages',
                    name: 'campaign-members-member-messages',
                    component: () => import(/* webpackChunkName: "campaign-members-member-messages" */ '../views/campaigns-partials/members/member/Messages.vue'),
                    meta: {
                      middleware: [auth, userHasCompletedData, advertiser]
                    }
                  },
                  {
                    path: 'files',
                    name: 'campaign-members-member-files',
                    component: () => import(/* webpackChunkName: "campaign-members-member-files" */ '../views/campaigns-partials/members/member/Files.vue'),
                    meta: {
                      middleware: [auth, userHasCompletedData, advertiser]
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'report',
            name: 'campaign-report',
            component: () => import(/* webpackChunkName: "campaign-report" */ '../views/campaigns-partials/Report.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, advertiser]
            }
          },
          {
            path: 'report-i',
            component: () => import(/* webpackChunkName: "campaign-report-influencer" */ '../views/campaigns-partials/ReportInfluencer.vue'),
            meta: {
              middleware: [auth, userHasCompletedData, influencer]
            },
            children: [
              {
                path: '',
                name: 'campaign-report-influencer',
                component: () => import(/* webpackChunkName: "campaign-report-influencer-details" */ '../views/campaigns-partials/influencer-report/ReportDetails.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, influencer]
                }
              },
              {
                path: ':key/save',
                name: 'campaign-report-influencer-save',
                component: () => import(/* webpackChunkName: "campaign-report-influencer-save" */ '../views/campaigns-partials/influencer-report/ReportSave.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData, influencer]
                }
              }
            ]
          }
        ]
      }
    ]
  },

  {
    path: '/campaigns-cpc',
    component: () => import(/* webpackChunkName: "campaigns-cpc" */ '../views/CampaignsCpc.vue'),
    meta: {
      middleware: [auth, userHasCompletedData]
    },
    children: [
      {
        path: '',
        name: 'campaigns-cpc',
        component: () => import(/* webpackChunkName: "campaigns-cpc-index" */ '../views/campaigns-cpc-partials/Index.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: ':id',
        name: 'campaign-cpc-details',
        component: () => import(/* webpackChunkName: "campaign-cpc-details" */ '../views/campaigns-cpc-partials/Details.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'add/:id?',
        name: 'campaign-cpc-add-edit',
        component: () => import(/* webpackChunkName: "campaign-cpc-add-edit" */ '../views/campaigns-cpc-partials/AddEdit.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, advertiser]
        }
      },
      {
        path: 'delete/:id',
        name: 'campaign-cpc-delete',
        component: () => import(/* webpackChunkName: "campaign-cpc-delete" */ '../views/campaigns-cpc-partials/Delete.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, advertiser]
        }
      },
      {
        path: 'credits/:id',
        name: 'campaign-cpc-credits',
        component: () => import(/* webpackChunkName: "campaign-cpc-credits" */ '../views/campaigns-cpc-partials/Credits.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, advertiser]
        }
      }
    ]
  },

  {
    path: '/profile',
    name: 'profile',
    redirect: '/profile/details',
    component: () => import(/* webpackChunkName: "profile" */ '../views/UserProfile.vue'),
    meta: {
      middleware: [auth, userHasCompletedData]
    },
    children: [
      {
        path: 'details',
        component: () => import(/* webpackChunkName: "empty-wrapper" */ '../views/EmptyWrapper.vue'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "profile-details" */ '../views/user-profile-partials/Details.vue'),
            meta: {
              middleware: [auth, userHasCompletedData]
            },
            children: [
              {
                path: '',
                name: 'profile-details',
                component: () => import(/* webpackChunkName: "profile-details-details" */ '../views/user-profile-partials/details-subviews/Details.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData]
                }
              },
              {
                path: 'audience',
                name: 'profile-audience',
                component: () => import(/* webpackChunkName: "profile-audience" */ '../views/user-profile-partials/details-subviews/Audience.vue'),
                meta: {
                  middleware: [auth, userHasCompletedData]
                }
              }
            ]
          },
          {
            path: 'edit',
            name: 'profile-personal-data-edit',
            component: () => import(/* webpackChunkName: "profile-personal-data-edit" */ '../views/user-profile-partials/EditPersonalData.vue'),
            meta: {
              middleware: [auth, userHasCompletedData]
            }
          }
        ]
      },
      {
        path: 'contract-edit',
        name: 'profile-contract-data-edit',
        component: () => import(/* webpackChunkName: "profile-contract-data-edit" */ '../views/user-profile-partials/EditContractData.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'search-subscription/:demo?',
        name: 'profile-search-subscription',
        component: () => import(/* webpackChunkName: "profile-search-subscription" */ '../views/user-profile-partials/SearchSubscription.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, advertiser]
        }
      },
      {
        path: 'archetypes',
        name: 'profile-archetypes',
        component: () => import(/* webpackChunkName: "profile-archetypes" */ '../views/user-profile-partials/Archetypes.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        }
      },
      {
        path: 'nativestars',
        name: 'profile-nativestars',
        component: () => import(/* webpackChunkName: "profile-nativestars" */ '../views/user-profile-partials/Nativestars.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        }
      }
    ]
  },

  {
    path: '/settings',
    name: 'settings',
    redirect: '/settings/password',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: {
      middleware: [auth]
    },
    children: [
      {
        path: 'password',
        name: 'settings-password',
        component: () => import(/* webpackChunkName: "settings-password-change" */ '../views/settings-partials/PasswordChange.vue'),
        meta: {
          middleware: [auth]
        }
      },
      {
        path: 'email',
        name: 'settings-email',
        component: () => import(/* webpackChunkName: "settings-email-change" */ '../views/settings-partials/EmailChange.vue'),
        meta: {
          middleware: [auth]
        }
      },
      {
        path: 'lang',
        name: 'settings-lang',
        component: () => import(/* webpackChunkName: "settings-lang-change" */ '../views/settings-partials/LangChange.vue'),
        meta: {
          middleware: [auth]
        }
      },
      {
        path: 'notifications',
        name: 'settings-notifications',
        component: () => import(/* webpackChunkName: "settings-notifications-change" */ '../views/settings-partials/NotificationsChange.vue'),
        meta: {
          middleware: [auth]
        }
      },
      {
        path: 'delete',
        name: 'settings-account-delete',
        component: () => import(/* webpackChunkName: "settings-account-delete" */ '../views/settings-partials/AccountDelete.vue'),
        meta: {
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/payments',
    component: () => import(/* webpackChunkName: "payments" */ '../views/Payments.vue'),
    meta: {
      middleware: [auth, userHasCompletedData]
    },
    children: [
      {
        path: '',
        name: 'payments',
        component: () => import(/* webpackChunkName: "payments-index" */ '../views/payments-partials/Index.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'withdraw',
        name: 'payments-withdraw',
        component: () => import(/* webpackChunkName: "payments-withdraw" */ '../views/payments-partials/Withdraw.vue'),
        meta: {
          middleware: [auth, userHasCompletedData, influencer]
        }
      }
    ]
  },
  {
    path: '/site/:url',
    name: 'site',
    component: () => import(/* webpackChunkName: "site" */ '../views/Site.vue'),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: '/public/:url',
    name: 'site-public',
    component: () => import(/* webpackChunkName: "site-public" */ '../views/SitePublic.vue'),
    meta: {
      middleware: [pubSite]
    }
  },
  {
    path: '/faq',
    name: 'faq',
    redirect: '/faq/faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ.vue'),
    meta: {
      middleware: [auth, userHasCompletedData]
    },
    children: [
      {
        path: 'faq',
        name: 'faq-faq',
        component: () => import(/* webpackChunkName: "faq-faq" */ '../views/faq-partials/faq.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'video',
        name: 'faq-videotutorial',
        component: () => import(/* webpackChunkName: "faq-videotutorial" */ '../views/faq-partials/videotutorial.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      },
      {
        path: 'contact',
        name: 'faq-contact-form',
        component: () => import(/* webpackChunkName: "faq-form" */ '../views/faq-partials/form.vue'),
        meta: {
          middleware: [auth, userHasCompletedData]
        }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  store.commit('loading/setRouterLoading', true)
  if (to.meta.middleware) {
    let redirected = false

    for (const i in to.meta.middleware) {
      if (await to.meta.middleware[i](to, from, next)) {
        redirected = true
        break
      }
    }

    if (!redirected) {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  store.commit('loading/setRouterLoading', false)
})

export default router
